import React from "react";
import styled, { withTheme } from "styled-components";
import PropTypes from "prop-types";

const Loading = ({ className }) => {
  return <div className={className} />;
};

Loading.propTypes = {
  className: PropTypes.string
};

const LoadingWithStyles = styled(Loading)`
  min-height: 400px;
  background-color: ${props => props.theme.loadings.iconContainerBgColor};
`;

export default withTheme(LoadingWithStyles);
